import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  SectionMessage,
  SectionMessageType,
} from '../SectionMessage/SectionMessage';
import Text, { TextType } from '../../Text/Text';
import { classes } from './BookForSomeoneElseBanner.st.css';
import { BookForSomeoneElseBannerDataHooks } from './dataHooks';

const BookForSomeoneElseBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SectionMessage
      type={SectionMessageType.Default}
      withoutIcon
      className={classes.root}
      dataHook={BookForSomeoneElseBannerDataHooks.BANNER}
    >
      <Text type={TextType.Primary} tagName="p" className={classes.body}>
        {t('bookings.form.bookForSomeoneElse.banner.body')}
      </Text>
    </SectionMessage>
  );
};

export default BookForSomeoneElseBanner;
